<script setup>
import { ref } from "vue";
import API from "../api/api-main";

const visible = ref(false);
const Branchs = ref([]);

const getBranch = async () => {
  try {
    const { data } = await API.get("Branch?skip=0&limit=1000");
    Branchs.value = data?.item || [];
  } catch (error) {}
};
getBranch();
</script>
<template>
  <Dialog
    v-model:visible="visible"
    modal
    :draggable="false"
    header="Thiết lập tài khoản"
    :style="{ width: '45rem' }"
  >
    <div class="card">
      <div class="flex flex-column gap-4">
        <div class="flex flex-column gap-2">
          <label> Chi nhánh/Cửa hàng </label>
          <Dropdown
            placeholder="Chọn chi nhánh"
            :options="Branchs"
            optionValue="id"
            optionLabel="branchName"
          ></Dropdown>
        </div>
        <div class="flex flex-column gap-2">
          <label> Quầy hàng </label>
          <Dropdown
            placeholder="Chọn quầy"
            optionValue="id"
            optionLabel="name"
            :options="
              Branchs.filter((e) => Branchs.includes(e.id)).flatMap((e) => e.counters)
            "
          ></Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-content-end gap-2">
        <Button
          type="button"
          label="Bỏ qua"
          severity="secondary"
          @click="visible = false"
        ></Button>
        <Button type="button" label="Xác nhận" @click="visible = false"></Button>
      </div>
    </template>
  </Dialog>
</template>
